import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initErrorMonitoring } from "./lib/monitoring";
import { initFontTelemetry } from "./lib/fontTelemetry";
import ErrorBoundary from "./components/ErrorBoundary";

initErrorMonitoring();
initFontTelemetry();

const rootEl = document.getElementById("root")!;

const tree = (
  <HelmetProvider>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </HelmetProvider>
);

// If the page was prerendered (react-snap), hydrate instead of remount
// so crawler-visible markup is preserved and interactivity attaches cleanly.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, tree);
} else {
  createRoot(rootEl).render(tree);
}
